import { Container, Row, Card, CardHeader, Table, Col, Form } from 'reactstrap';
import SimpleHeader from '../../../../components/Headers/SimpleHeader';
import ReactButton from '../../../../components/Buttons/ReactButton';
import React, { useState, useEffect, useCallback } from 'react';
import ReactLoader from '../../../../components/Loader';
import { useForm, Controller } from 'react-hook-form';
import { useDebouncedCallback } from 'use-debounce';
import { useGetStock } from './hooks/useGetStock';
import StockService from './service/StockService';
import BranchService from '../../Branch/service';
import { InputTable, Tr } from './styles';
import { toast } from 'react-toastify';
import Select from 'react-select';

const Stock = (props) => {
  const [option, setOption] = useState(null);
  const [dias, setDias] = useState([]);
  const { handleSubmit, control } = useForm();
  const [data, setData] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const { id } = props.match.params;
  const { stockList } = useGetStock(id);
  const [options, setOptions] = useState([]);
  const [filial, setFilial] = useState('');
  const [empresa, setEmpresa] = useState('');

  const columns = [
    'Dias/Hora',
    '06:00-07:00',
    '07:00-08:00',
    '08:00-09:00',
    '09:00-10:00',
    '10:00-11:00',
    '11:00-12:00',
    '12:00-13:00',
    '13:00-14:00',
    '14:00-15:00',
    '15:00-16:00',
    '16:00-17:00',
    '17:00-18:00',
    '18:00-19:00',
    '19:00-20:00',
    '20:00-21:00',
    'CIF',
    'FOB',
    'TOTAL DIA'
  ];

  const generateDias = () => {
    // let arrayDias = getDate();
    let arrayDias = [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      22, 23, 24, 25, 26, 27, 28, 29, 30, 31
    ];
    let dias = arrayDias.map(() => {
      return {
        seisAsSete: '',
        seteAsOito: '',
        oitoAsNove: '',
        noveAsDez: '',
        dezAsOnze: '',
        onzeAsDoze: '',
        dozeAsTreze: '',
        trezeAsQuartorze: '',
        quartorzeAsQuinze: '',
        quinzeAsDezesseis: '',
        dezesseisAsDezessete: '',
        dezesseteAsDezoito: '',
        dezoitoAsDezenove: '',
        dezenoveAsVinte: '',
        VinteAsVinteEum: '',
        CIF: ''
      };
    });
    setDias(dias);
    setData(dias);
  };

  const generateOptions = () => {
    if (stockList.length > 0) {
      let productOptions = stockList.map((produto) => {
        return { value: produto.id, label: produto.nome };
      });

      setOptions(productOptions);
    }
  };

  useEffect(() => {
    getProductStock();
  }, [option]);

  useEffect(() => {
    generateOptions();
    generateDias();
    getBranchInfo();
  }, [stockList]);

  const treatInput = (event) => {
    if (event === '' || isNaN(event)) {
      event = '';
      let value = 0;
      return value;
    } else {
      event = event.replace(/\D/g, '');
      let value = parseInt(event);
      return value;
    }
  };

  const handleOnChange = useDebouncedCallback(
    (event, index, onChange, hora = '') => {
      let value = parseInt(event);
      let newDias = [...dias];
      let object = newDias[index];

      object[hora] = value;
      newDias[index] = { ...object };
      setDias(newDias);
      onChange(value);
    },
    50
  );

  const getBranchInfo = async () => {
    {
      await BranchService.get(`${id}`)
        .then((res) => {
          setFilial(res.data.data.nome);
          setEmpresa(res.data.data.empresa);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const getProductStock = () => {
    if (option) {
      setIsLoading(true);
      StockService.get(`?filial=${id}&produto=${option.value}`)
        .then((res) => {
          if (res.data.data.length > 0) {
            let sortedTeste = res.data.data.sort((a, b) => {
              return a.dia - b.dia;
            });
            console.log('sortedTeste', sortedTeste);
            let newDias = sortedTeste.map((dia) => {
              return {
                seisAsSete:
                  dia.estoquesPorHora[0] &&
                  dia.estoquesPorHora[0].quantidade !== 0
                    ? dia.estoquesPorHora[0].quantidade
                    : '',
                seteAsOito:
                  dia.estoquesPorHora[1] &&
                  dia.estoquesPorHora[1].quantidade !== 0
                    ? dia.estoquesPorHora[1].quantidade
                    : '',
                oitoAsNove:
                  dia.estoquesPorHora[2] &&
                  dia.estoquesPorHora[2].quantidade !== 0
                    ? dia.estoquesPorHora[2].quantidade
                    : '',
                noveAsDez:
                  dia.estoquesPorHora[3] &&
                  dia.estoquesPorHora[3].quantidade !== 0
                    ? dia.estoquesPorHora[3].quantidade
                    : '',
                dezAsOnze:
                  dia.estoquesPorHora[4] &&
                  dia.estoquesPorHora[4].quantidade !== 0
                    ? dia.estoquesPorHora[4].quantidade
                    : '',
                onzeAsDoze:
                  dia.estoquesPorHora[5] &&
                  dia.estoquesPorHora[5].quantidade !== 0
                    ? dia.estoquesPorHora[5].quantidade
                    : '',
                dozeAsTreze:
                  dia.estoquesPorHora[6] &&
                  dia.estoquesPorHora[6].quantidade !== 0
                    ? dia.estoquesPorHora[6].quantidade
                    : '',
                trezeAsQuartorze:
                  dia.estoquesPorHora[7] &&
                  dia.estoquesPorHora[7].quantidade !== 0
                    ? dia.estoquesPorHora[7].quantidade
                    : '',
                quartorzeAsQuinze:
                  dia.estoquesPorHora[8] &&
                  dia.estoquesPorHora[8].quantidade !== 0
                    ? dia.estoquesPorHora[8].quantidade
                    : '',
                quinzeAsDezesseis:
                  dia.estoquesPorHora[9] &&
                  dia.estoquesPorHora[9].quantidade !== 0
                    ? dia.estoquesPorHora[9].quantidade
                    : '',
                dezesseisAsDezessete:
                  dia.estoquesPorHora[10] &&
                  dia.estoquesPorHora[10].quantidade !== 0
                    ? dia.estoquesPorHora[10].quantidade
                    : '',
                dezesseteAsDezoito:
                  dia.estoquesPorHora[11] &&
                  dia.estoquesPorHora[11].quantidade !== 0
                    ? dia.estoquesPorHora[11].quantidade
                    : '',
                dezoitoAsDezenove:
                  dia.estoquesPorHora[12] &&
                  dia.estoquesPorHora[12].quantidade !== 0
                    ? dia.estoquesPorHora[12].quantidade
                    : '',
                dezenoveAsVinte:
                  dia.estoquesPorHora[13] &&
                  dia.estoquesPorHora[13].quantidade !== 0
                    ? dia.estoquesPorHora[13].quantidade
                    : '',
                VinteAsVinteEum:
                  dia.estoquesPorHora[14] &&
                  dia.estoquesPorHora[14].quantidade !== 0
                    ? dia.estoquesPorHora[14].quantidade
                    : '',
                CIF: dia.cif
              };
            });
            setDias(newDias);
            setIsLoading(false);
          } else {
            generateDias();
            setIsLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const onSubmit = (e) => {
    let estoque = Object.values(e);

    const sliceArray = (arr, chunkSize) => {
      let tempArray = [];

      for (let i = 0; i < arr.length; i += chunkSize) {
        let teste = arr.slice(i, i + chunkSize);
        tempArray.push(teste);
      }
      return tempArray;
    };
    let arrayDias = sliceArray(estoque, 16);

    const objectToSend = arrayDias.map((dia, index) => {
      let objetoDia = {
        cif: dia[15] === '' ? 0 : dia[15],
        total:
          dia.reduce((acc, value) => {
            acc += +value;
            return acc;
          }, 0) - dia[15],
        dia: index + 1,
        produtoId: option.value,
        filialId: parseInt(id),
        estoquesPorHora: [
          {
            horaInicial: '06:00:00',
            horaFinal: '07:00:00',
            quantidade: dia[0] === '' ? 0 : dia[0]
          },
          {
            horaInicial: '07:00:00',
            horaFinal: '08:00:00',
            quantidade: dia[1] === '' ? 0 : dia[1]
          },
          {
            horaInicial: '08:00:00',
            horaFinal: '09:00:00',
            quantidade: dia[2] === '' ? 0 : dia[2]
          },
          {
            horaInicial: '09:00:00',
            horaFinal: '10:00:00',
            quantidade: dia[3] === '' ? 0 : dia[3]
          },
          {
            horaInicial: '10:00:00',
            horaFinal: '11:00:00',
            quantidade: dia[4] === '' ? 0 : dia[4]
          },
          {
            horaInicial: '11:00:00',
            horaFinal: '12:00:00',
            quantidade: dia[5] === '' ? 0 : dia[5]
          },
          {
            horaInicial: '12:00:00',
            horaFinal: '13:00:00',
            quantidade: dia[6] === '' ? 0 : dia[6]
          },
          {
            horaInicial: '13:00:00',
            horaFinal: '14:00:00',
            quantidade: dia[7] === '' ? 0 : dia[7]
          },
          {
            horaInicial: '14:00:00',
            horaFinal: '15:00:00',
            quantidade: dia[8] === '' ? 0 : dia[8]
          },
          {
            horaInicial: '15:00:00',
            horaFinal: '16:00:00',
            quantidade: dia[9] === '' ? 0 : dia[9]
          },
          {
            horaInicial: '16:00:00',
            horaFinal: '17:00:00',
            quantidade: dia[10] === '' ? 0 : dia[10]
          },
          {
            horaInicial: '17:00:00',
            horaFinal: '18:00:00',
            quantidade: dia[11] === '' ? 0 : dia[11]
          },
          {
            horaInicial: '18:00:00',
            horaFinal: '19:00:00',
            quantidade: dia[12] === '' ? 0 : dia[12]
          },
          {
            horaInicial: '19:00:00',
            horaFinal: '20:00:00',
            quantidade: dia[13] === '' ? 0 : dia[13]
          },
          {
            horaInicial: '20:00:00',
            horaFinal: '21:00:00',
            quantidade: dia[14] === '' ? 0 : dia[14]
          }
        ]
      };

      return objetoDia;
    });

    console.log(objectToSend);
    StockService.put('', objectToSend)
      .then(() => {
        toast.success('Estoque atualizado com sucesso!', {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .catch(() => {
        StockService.post('', objectToSend)
          .then(() => {
            toast.success('Estoque atualizado com sucesso!', {
              autoClose: 3000,
              closeOnClick: true
            });
          })
          .catch((error) => {
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.log(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message);
            }
            console.log(error.config);
          });
      });
  };

  const onError = (errors) => {
    console.log(errors);
    toast.error('O CIF não pode ser maior que o total!', {
      autoClose: 3000,
      closeOnClick: true
    });
  };

  const getTotal = useCallback(
    (index) => {
      if (dias[index]) {
        let valoresDia = Object.values(dias[index]);
        valoresDia.pop();
        return valoresDia.reduce((acc, value) => {
          acc += +value;
          return acc;
        }, 0);
      } else {
        return 0;
      }
    },
    [dias]
  );

  const getTotalMonth = useCallback(() => {
    if (dias && option) {
      let totalMonth = dias
        .map((dia) => {
          let totalDia = Object.values(dia);
          totalDia.pop();
          return totalDia.reduce((acc, value) => {
            acc += +value;
            return acc;
          }, 0);
        })
        .reduce((acc, value) => {
          acc += value;
          return acc;
        }, 0);
      return totalMonth;
    } else {
      return 0;
    }
  }, [dias]);

  const calculateFob = useCallback(
    (index) => {
      if (dias[index]) {
        let valoresDia = Object.values(dias[index]);
        let cif = valoresDia.pop();
        let totalDia = valoresDia.reduce((acc, value) => {
          acc += +value;
          return acc;
        }, 0);

        return totalDia - cif;
      }
    },
    [dias]
  );

  // const getDate = () => {
  //   let dt = new Date();
  //   let month = dt.getMonth();
  //   let year = dt.getFullYear();
  //   let daysInMonth = new Date(year, month + 1, 0).getDate();
  //   let arrayDias = [...Array(daysInMonth).keys()];

  //   return arrayDias;
  // };

  return (
    <>
      <SimpleHeader
        name="Form validation"
        parentName="Forms"
        returnPath="/admin/branch/list/"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card style={{ overflow: 'hidden' }}>
                <CardHeader>
                  <h3 className="mb-0">
                    Estoque da filial {filial} - {empresa}
                  </h3>
                </CardHeader>

                <Row className="mt-3 mx-2">
                  <Col md="8" style={{ zIndex: '1000' }}>
                    <Select
                      defaultValue={option}
                      onChange={setOption}
                      options={options}
                      placeholder={'selecionar produto...'}
                    />
                  </Col>
                </Row>
                <Row style={{ overflow: 'auto' }}>
                  <Form
                    style={{
                      height: '40rem',
                      width: '100%'
                    }}
                    onSubmit={handleSubmit(onSubmit, onError)}
                  >
                    {isLoading ? (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          padding: `1rem`
                        }}
                      >
                        <ReactLoader />
                      </div>
                    ) : (
                      <Table style={{ margin: '1.5rem' }}>
                        <thead>
                          <tr>
                            {columns.map((column, index) => (
                              <th
                                className="col-xs-3"
                                style={{
                                  zIndex: '100',
                                  textAlign: 'center',
                                  position: 'sticky',
                                  top: '0',
                                  fontWeight: 'bold',
                                  padding: '1rem',
                                  backgroundColor: '#f6f9fc'
                                }}
                                key={index}
                              >
                                {column}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {data.map((item, index) => {
                            return (
                              <Tr key={index}>
                                <td
                                  style={{
                                    padding: '1rem 0',
                                    position: 'sticky',
                                    left: '0',
                                    backgroundColor: 'white'
                                  }}
                                >
                                  {index + 1}
                                </td>

                                <td style={{ padding: '1rem 0' }}>
                                  <Controller
                                    render={({ onChange }) => (
                                      <InputTable
                                        editable={true}
                                        defaultValue={
                                          dias ? dias[index]['seisAsSete'] : 0
                                        }
                                        onChange={(event) => {
                                          let value = treatInput(
                                            event.target.value
                                          );
                                          event.target.value = value;

                                          handleOnChange(
                                            value,
                                            index,
                                            onChange,
                                            'seisAsSete'
                                          );
                                        }}
                                      />
                                    )}
                                    defaultValue={
                                      dias.length > 0
                                        ? dias
                                          ? dias[index]['seisAsSete']
                                          : 0
                                        : 0
                                    }
                                    control={control}
                                    name={`Dia ${index + 1} 06:00-07:00`}
                                    onChange={(val) => {
                                      return val;
                                    }}
                                  />
                                </td>

                                <td style={{ padding: '1rem 0' }}>
                                  <Controller
                                    render={({ onChange }) => (
                                      <InputTable
                                        defaultValue={
                                          dias.length > 0
                                            ? dias
                                              ? dias[index]['seteAsOito']
                                              : 0
                                            : 0
                                        }
                                        editable={true}
                                        onChange={(event) => {
                                          let value = treatInput(
                                            event.target.value
                                          );
                                          event.target.value = value;

                                          handleOnChange(
                                            value,
                                            index,
                                            onChange,
                                            'seteAsOito'
                                          );
                                        }}
                                      />
                                    )}
                                    defaultValue={
                                      dias.length > 0
                                        ? dias
                                          ? dias[index]['seteAsOito']
                                          : 0
                                        : 0
                                    }
                                    control={control}
                                    name={`Dia ${index + 1} 07:00-08:00`}
                                    onChange={(val) => {
                                      return val;
                                    }}
                                  />
                                </td>

                                <td style={{ padding: '1rem 0' }}>
                                  <Controller
                                    render={({ onChange }) => (
                                      <InputTable
                                        defaultValue={
                                          dias.length > 0
                                            ? dias
                                              ? dias[index]['oitoAsNove']
                                              : 0
                                            : 0
                                        }
                                        editable={true}
                                        onChange={(event) => {
                                          let value = treatInput(
                                            event.target.value
                                          );
                                          event.target.value = value;

                                          handleOnChange(
                                            value,
                                            index,
                                            onChange,
                                            'oitoAsNove'
                                          );
                                        }}
                                      />
                                    )}
                                    defaultValue={
                                      dias.length > 0
                                        ? dias
                                          ? dias[index]['oitoAsNove']
                                          : 0
                                        : 0
                                    }
                                    control={control}
                                    name={`Dia ${index + 1} 08:00-09:00`}
                                  />
                                </td>

                                <td style={{ padding: '1rem 0' }}>
                                  <Controller
                                    render={({ onChange }) => (
                                      <InputTable
                                        defaultValue={
                                          dias ? dias[index]['noveAsDez'] : 0
                                        }
                                        editable={true}
                                        onChange={(event) => {
                                          let value = treatInput(
                                            event.target.value
                                          );
                                          event.target.value = value;

                                          handleOnChange(
                                            value,
                                            index,
                                            onChange,
                                            'noveAsDez'
                                          );
                                        }}
                                      />
                                    )}
                                    defaultValue={
                                      dias ? dias[index]['noveAsDez'] : 0
                                    }
                                    control={control}
                                    name={`Dia ${index + 1} 09:00-10:00`}
                                  />
                                </td>

                                <td style={{ padding: '1rem 0' }}>
                                  <Controller
                                    render={({ onChange }) => (
                                      <InputTable
                                        defaultValue={
                                          dias ? dias[index]['dezAsOnze'] : 0
                                        }
                                        editable={true}
                                        onChange={(event) => {
                                          let value = treatInput(
                                            event.target.value
                                          );
                                          event.target.value = value;

                                          handleOnChange(
                                            value,
                                            index,
                                            onChange,
                                            'dezAsOnze'
                                          );
                                        }}
                                      />
                                    )}
                                    defaultValue={
                                      dias ? dias[index]['dezAsOnze'] : 0
                                    }
                                    control={control}
                                    name={`Dia ${index + 1} 10:00-11:00`}
                                  />
                                </td>

                                <td style={{ padding: '1rem 0' }}>
                                  <Controller
                                    render={({ onChange }) => (
                                      <InputTable
                                        defaultValue={
                                          dias.length > 0
                                            ? dias
                                              ? dias[index]['onzeAsDoze']
                                              : 0
                                            : 0
                                        }
                                        editable={true}
                                        onChange={(event) => {
                                          let value = treatInput(
                                            event.target.value
                                          );
                                          event.target.value = value;

                                          handleOnChange(
                                            value,
                                            index,
                                            onChange,
                                            'onzeAsDoze'
                                          );
                                        }}
                                      />
                                    )}
                                    defaultValue={
                                      dias.length > 0
                                        ? dias
                                          ? dias[index]['onzeAsDoze']
                                          : (0).quantidade
                                        : 0
                                    }
                                    control={control}
                                    name={`Dia ${index + 1} 11:00-12:00`}
                                  />
                                </td>

                                <td style={{ padding: '1rem 0' }}>
                                  <Controller
                                    render={({ onChange }) => (
                                      <InputTable
                                        defaultValue={
                                          dias.length > 0
                                            ? dias[index]['dozeAsTreze']
                                            : 0
                                        }
                                        editable={true}
                                        onChange={(event) => {
                                          let value = treatInput(
                                            event.target.value
                                          );
                                          event.target.value = value;

                                          handleOnChange(
                                            value,
                                            index,
                                            onChange,
                                            'dozeAsTreze'
                                          );
                                        }}
                                      />
                                    )}
                                    defaultValue={
                                      dias.length > 0
                                        ? dias[index]['dozeAsTreze']
                                        : 0
                                    }
                                    control={control}
                                    name={`Dia ${index + 1} 12:00-13:00`}
                                  />
                                </td>

                                <td style={{ padding: '1rem 0' }}>
                                  <Controller
                                    render={({ onChange }) => (
                                      <InputTable
                                        defaultValue={
                                          dias.length > 0
                                            ? dias[index]['trezeAsQuartorze']
                                            : 0
                                        }
                                        editable={true}
                                        onChange={(event) => {
                                          let value = treatInput(
                                            event.target.value
                                          );
                                          event.target.value = value;

                                          handleOnChange(
                                            value,
                                            index,
                                            onChange,
                                            'trezeAsQuartorze'
                                          );
                                        }}
                                      />
                                    )}
                                    defaultValue={
                                      dias.length > 0
                                        ? dias[index]['trezeAsQuartorze']
                                        : 0
                                    }
                                    control={control}
                                    name={`Dia ${index + 1} 13:00-14:00`}
                                  />
                                </td>

                                <td style={{ padding: '1rem 0' }}>
                                  <Controller
                                    render={({ onChange }) => (
                                      <InputTable
                                        defaultValue={
                                          dias
                                            ? dias[index]['quartorzeAsQuinze']
                                            : 0
                                        }
                                        editable={true}
                                        onChange={(event) => {
                                          let value = treatInput(
                                            event.target.value
                                          );
                                          event.target.value = value;

                                          handleOnChange(
                                            value,
                                            index,
                                            onChange,
                                            'quartorzeAsQuinze'
                                          );
                                        }}
                                      />
                                    )}
                                    defaultValue={
                                      dias
                                        ? dias[index]['quartorzeAsQuinze']
                                        : 0
                                    }
                                    control={control}
                                    name={`Dia ${index + 1} 14:00-15:00`}
                                  />
                                </td>

                                <td style={{ padding: '1rem 0' }}>
                                  <Controller
                                    render={({ onChange }) => (
                                      <InputTable
                                        defaultValue={
                                          dias
                                            ? dias[index]['quinzeAsDezesseis']
                                            : 0
                                        }
                                        editable={true}
                                        onChange={(event) => {
                                          let value = treatInput(
                                            event.target.value
                                          );
                                          event.target.value = value;

                                          handleOnChange(
                                            value,
                                            index,
                                            onChange,
                                            'quinzeAsDezesseis'
                                          );
                                        }}
                                      />
                                    )}
                                    defaultValue={
                                      dias
                                        ? dias[index]['quinzeAsDezesseis']
                                        : 0
                                    }
                                    control={control}
                                    name={`Dia ${index + 1} 15:00-16:00`}
                                  />
                                </td>

                                <td style={{ padding: '1rem 0' }}>
                                  <Controller
                                    render={({ onChange }) => (
                                      <InputTable
                                        defaultValue={
                                          dias.length > 0
                                            ? dias[index][
                                                'dezesseisAsDezessete'
                                              ]
                                            : 0
                                        }
                                        editable={true}
                                        onChange={(event) => {
                                          let value = treatInput(
                                            event.target.value
                                          );
                                          event.target.value = value;

                                          handleOnChange(
                                            value,
                                            index,
                                            onChange,
                                            'dezesseisAsDezessete'
                                          );
                                        }}
                                      />
                                    )}
                                    defaultValue={
                                      dias.length > 0
                                        ? dias[index]['dezesseisAsDezessete']
                                        : 0
                                    }
                                    control={control}
                                    name={`Dia ${index + 1} 16:00-17:00`}
                                  />
                                </td>

                                <td style={{ padding: '1rem 0' }}>
                                  <Controller
                                    render={({ onChange }) => (
                                      <InputTable
                                        defaultValue={
                                          dias.length > 0
                                            ? dias[index]['dezesseteAsDezoito']
                                            : 0
                                        }
                                        editable={true}
                                        onChange={(event) => {
                                          let value = treatInput(
                                            event.target.value
                                          );
                                          event.target.value = value;

                                          handleOnChange(
                                            value,
                                            index,
                                            onChange,
                                            'dezesseteAsDezoito'
                                          );
                                        }}
                                      />
                                    )}
                                    defaultValue={
                                      dias.length > 0
                                        ? dias[index]['dezesseteAsDezoito']
                                        : 0
                                    }
                                    control={control}
                                    name={`Dia ${index + 1} 17:00-18:00`}
                                  />
                                </td>

                                <td style={{ padding: '1rem 0' }}>
                                  <Controller
                                    render={({ onChange }) => (
                                      <InputTable
                                        defaultValue={
                                          dias.length > 0
                                            ? dias[index]['dezoitoAsDezenove']
                                            : 0
                                        }
                                        editable={true}
                                        onChange={(event) => {
                                          let value = treatInput(
                                            event.target.value
                                          );
                                          event.target.value = value;

                                          handleOnChange(
                                            value,
                                            index,
                                            onChange,
                                            'dezoitoAsDezenove'
                                          );
                                        }}
                                      />
                                    )}
                                    defaultValue={
                                      dias.length > 0
                                        ? dias[index]['dezoitoAsDezenove']
                                        : 0
                                    }
                                    control={control}
                                    name={`Dia ${index + 1} 18:00-19:00`}
                                  />
                                </td>

                                <td style={{ padding: '1rem 0' }}>
                                  <Controller
                                    render={({ onChange }) => (
                                      <InputTable
                                        defaultValue={
                                          dias.length > 0
                                            ? dias[index]['dezenoveAsVinte']
                                            : 0
                                        }
                                        editable={true}
                                        onChange={(event) => {
                                          let value = treatInput(
                                            event.target.value
                                          );
                                          event.target.value = value;

                                          handleOnChange(
                                            value,
                                            index,
                                            onChange,
                                            'dezenoveAsVinte'
                                          );
                                        }}
                                      />
                                    )}
                                    defaultValue={
                                      dias.length > 0
                                        ? dias[index]['dezenoveAsVinte']
                                        : 0
                                    }
                                    control={control}
                                    name={`Dia ${index + 1} 19:00-20:00`}
                                  />
                                </td>

                                <td style={{ padding: '1rem 0' }}>
                                  <Controller
                                    render={({ onChange }) => (
                                      <InputTable
                                        defaultValue={
                                          dias.length > 0
                                            ? dias[index]['VinteAsVinteEum']
                                            : 0
                                        }
                                        editable={true}
                                        onChange={(event) => {
                                          let value = treatInput(
                                            event.target.value
                                          );
                                          event.target.value = value;

                                          handleOnChange(
                                            value,
                                            index,
                                            onChange,
                                            'VinteAsVinteEum'
                                          );
                                        }}
                                      />
                                    )}
                                    defaultValue={
                                      dias.length > 0
                                        ? dias[index]['VinteAsVinteEum']
                                        : 0
                                    }
                                    control={control}
                                    name={`Dia ${index + 1} 20:00-21:00`}
                                  />
                                </td>
                                <td style={{ padding: '1rem 0' }}>
                                  <Controller
                                    render={({ onChange }) => (
                                      <InputTable
                                        defaultValue={
                                          dias.length > 0
                                            ? dias[index]['CIF']
                                            : 0
                                        }
                                        editable={true}
                                        onChange={(event) => {
                                          let value = treatInput(
                                            event.target.value
                                          );
                                          event.target.value = value;

                                          handleOnChange(
                                            value,
                                            index,
                                            onChange,
                                            'CIF'
                                          );
                                        }}
                                      />
                                    )}
                                    defaultValue={dias ? dias[index]['CIF'] : 0}
                                    control={control}
                                    name={`Dia ${index + 1} CIF`}
                                  />
                                </td>
                                <td style={{ padding: '1rem 0' }}>
                                  {calculateFob(index)}
                                </td>
                                <td style={{ padding: '1rem 0' }}>
                                  {getTotal(index)}
                                </td>
                              </Tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    )}
                    <h4
                      style={{ marginLeft: '3rem' }}
                    >{`Total do mês = ${getTotalMonth()}`}</h4>
                    <div style={{ marginLeft: '3rem', marginBottom: '1.5rem' }}>
                      {' '}
                      <ReactButton
                        // style={{
                        //   backgroundColor: `${option ? '' : 'transparent'}`
                        // }}
                        disabled={option ? false : true}
                        type="submit"
                      >
                        Salvar
                      </ReactButton>
                    </div>
                  </Form>
                </Row>
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Stock;
